import { graphql } from "react-relay";

export const CREATE_FREE_TEXT_SELF_CHECK_ELEMENT_MUTATION = graphql`
	mutation createFreeTextSelfCheckElementButton_CreateFreeTextSelfCheckElementMutation(
		$input: CreateFreeTextSelfCheckElementInput!
	) {
		Admin {
			ElearningV2 {
				createFreeTextSelfCheckElement(input: $input) {
					eLearningContent {
						...contentCard_TreeNodeFragment
					}
				}
			}
		}
	}
`;
